import { render, staticRenderFns } from "./CmgNooHomePage.vue?vue&type=template&id=191b16e1&scoped=true&lang=pug&"
import script from "./cmg-noo-home-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-noo-home-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNooHomePage.vue?vue&type=style&index=0&id=191b16e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191b16e1",
  null
  
)

export default component.exports